import { BrowserRouter, Routes, Route } from 'react-router-dom';
import GlobalLoader from './components/common/GlobalLoader';

// Landing Page
import Landing from './components/pages/landing';
import Privacy from './components/pages/common/Privacy';
import Terms from './components/pages/common/Terms';
import DeleteAccount from './components/pages/common/DeleteAccount';
import { useEffect } from 'react';

const App = () => {

  useEffect(() => {
    if(localStorage.getItem("isShowTour") == null) {
      localStorage.setItem("isShowTour", "true");
    }
  }, [localStorage.getItem("isShowTour")])

  return (
    <BrowserRouter>
      <GlobalLoader />
      <Routes>
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/*" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}
export default App;